import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBoyHrmnQgjFFXv2Ar_ECVtAhynlb67EZI",
  authDomain: "renovations-ai.firebaseapp.com",
  projectId: "renovations-ai",
  storageBucket: "renovations-ai.firebasestorage.app",
  messagingSenderId: "357845714656",
  appId: "1:357845714656:web:0b0cc0c5595149e692f285",
  measurementId: "G-EZW9RK2NWM"
};

// Initialize Firebase (prevent re-initialization in hot reload)
export const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
